// extracted by mini-css-extract-plugin
export default {"StrategyParamsContainer":"styles_StrategyParamsContainer__fTH4W","title":"styles_title__zrD9-","buttons":"styles_buttons__QSIi1","controls":"styles_controls__AMi9b"};